// extracted by mini-css-extract-plugin
module.exports = {"container":"UnknownNobt__container--1ljQw","icon":"UnknownNobt__icon--_X2uq"};